import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import classNames from 'classnames';
/**
 * Manager-mode footer: instead of the picker's "Select N", the selection feeds
 * bulk actions (delete, move, …) supplied by the provider plugin.
 */
export default function BulkActions({ selectedCount, bulkActions, runBulkAction, i18n, }) {
    if (selectedCount === 0 || bulkActions.length === 0)
        return null;
    return (_jsx("div", { className: "uppy-ProviderBrowser-footer", children: _jsxs("div", { className: "uppy-ProviderBrowser-footer-buttons", children: [_jsx("span", { className: "uppy-ProviderBrowser-footer-count", children: i18n('itemsSelected', { smart_count: selectedCount }) }), bulkActions.map((action) => (_jsx("button", { type: "button", className: classNames('uppy-u-reset uppy-c-btn uppy-c-btn-primary', {
                        'uppy-ProviderDialog-confirm--danger': action.danger,
                    }), onClick: () => runBulkAction(action), children: action.label }, action.id)))] }) }));
}
